import {
  IconCalendarAlt,
  IconClockTwo,
  IconFile,
  IconHistory,
} from '@maia/icons';
import { InsuranceDto } from '@maia/shared';
import { cardStyles, SectionWithHeader, SpecList } from '@maia/ui';
import { formatDate } from '@maia/utils';
import { twMerge } from 'tailwind-merge';

type Props = {
  insurance: InsuranceDto;
};

export function ContractInformationCard(props: Props) {
  const { insurance } = props;
  return (
    <SectionWithHeader title="Contract">
      <div className={twMerge(cardStyles({ variant: 'outlined' }), 'p-20')}>
        <SpecList
          items={[
            {
              icon: IconFile,
              title: 'Polisnummer',
              value: insurance.reference,
              isHalf: true,
            },
            {
              icon: IconCalendarAlt,
              title: 'Ingangsdatum',
              value: formatDate(insurance.effectiveDate),
              isHalf: true,
            },
            {
              icon: IconClockTwo,
              title: 'Premievervaldatum',
              value: formatDate(insurance.premiumDueDate),
              isHalf: true,
            },
            {
              icon: IconHistory,
              title: 'Automatische verlenging',
              value: 'Actief',
              isHalf: true,
            },
          ]}
        />
      </div>
    </SectionWithHeader>
  );
}
